import { ExpandableSection } from "../ExpandableSection";
import { Table } from "../Table";

const Section = ({ items, classes }) =>
  items?.length > 0 && (
    <ExpandableSection title="Video Metrics" classes={classes}>
      <Table
        classes={classes}
        columns={tableColumns}
        items={items}
        keyField="title"
      />
    </ExpandableSection>
  );

const tableColumns = [
  { xs: 6, sm: 6, md: 6, label: "Video Title", field: "title" },
  {
    xs: 3,
    sm: 3,
    md: 3,
    label: "Video Progress 25%",
    field: "progress25",
    render: (data) =>
      Math.max(
        data.videoProgress.progress25 - data.videoProgress.progress50,
        0,
      ),
  },
  {
    xs: 1,
    sm: 1,
    md: 1,
    label: "50%",
    field: "progress50",
    render: (data) =>
      Math.max(
        data.videoProgress.progress50 - data.videoProgress.progress75,
        0,
      ),
  },
  {
    xs: 1,
    sm: 1,
    md: 1,
    label: "75%",
    field: "progress75",
    render: (data) =>
      Math.max(
        data.videoProgress.progress75 - data.videoProgress.progress100,
        0,
      ),
  },
  {
    xs: 1,
    sm: 1,
    md: 1,
    label: "100%",
    field: "progress100",
    render: (data) => data.videoProgress.progress100,
  },
];

export default Section;
